window.IR_SECOND_PAGE_PRINTER_CATALOGS = window.IR_SECOND_PAGE_PRINTER_CATALOGS || {};
window.IR_SECOND_PAGE_PRINTER_CATALOGS["brotherprinter"] = {
  "groupCount": 11,
  "modelCount": 212,
  "groups": [
    {
      "order": 1,
      "name": "HL-Jシリーズ",
      "models": [
        {
          "order": 1,
          "model": "HL-J6000CDW",
          "shopifyUrl": "/collections/hl-j6000cdw"
        },
        {
          "order": 2,
          "model": "HL-J7010CDW",
          "shopifyUrl": "/collections/hl-j7010cdw"
        }
      ]
    },
    {
      "order": 2,
      "name": "DCPシリーズ",
      "models": [
        {
          "order": 1,
          "model": "DCP-110C",
          "shopifyUrl": "/collections/dcp-110c"
        },
        {
          "order": 2,
          "model": "DCP-115C",
          "shopifyUrl": "/collections/dcp-115c"
        },
        {
          "order": 3,
          "model": "DCP-155C",
          "shopifyUrl": "/collections/dcp-155c"
        },
        {
          "order": 4,
          "model": "DCP-165C",
          "shopifyUrl": "/collections/dcp-165c"
        },
        {
          "order": 5,
          "model": "DCP-330C",
          "shopifyUrl": "/collections/dcp-330c"
        },
        {
          "order": 6,
          "model": "DCP-350C",
          "shopifyUrl": "/collections/dcp-350c"
        },
        {
          "order": 7,
          "model": "DCP-385C",
          "shopifyUrl": "/collections/dcp-385c"
        },
        {
          "order": 8,
          "model": "DCP-390CN",
          "shopifyUrl": "/collections/dcp-390cn"
        },
        {
          "order": 9,
          "model": "DCP-535CN",
          "shopifyUrl": "/collections/dcp-535cn"
        },
        {
          "order": 10,
          "model": "DCP-595CN",
          "shopifyUrl": "/collections/dcp-595cn"
        },
        {
          "order": 11,
          "model": "DCP-750CN",
          "shopifyUrl": "/collections/dcp-750cn"
        },
        {
          "order": 12,
          "model": "DCP-770CN",
          "shopifyUrl": "/collections/dcp-770cn"
        }
      ]
    },
    {
      "order": 3,
      "name": "DCP-Jシリーズ",
      "models": [
        {
          "order": 1,
          "model": "DCP-J1200N",
          "shopifyUrl": "/collections/dcp-j1200n"
        },
        {
          "order": 2,
          "model": "DCP-J1203N",
          "shopifyUrl": "/collections/dcp-j1203n"
        },
        {
          "order": 3,
          "model": "DCP-J1800N",
          "shopifyUrl": "/collections/dcp-j1800n"
        },
        {
          "order": 4,
          "model": "DCP-J132N",
          "shopifyUrl": "/collections/dcp-j132n"
        },
        {
          "order": 5,
          "model": "DCP-J137N",
          "shopifyUrl": "/collections/dcp-j137n"
        },
        {
          "order": 6,
          "model": "DCP-J152N",
          "shopifyUrl": "/collections/dcp-j152n"
        },
        {
          "order": 7,
          "model": "DCP-J4140N",
          "shopifyUrl": "/collections/dcp-j4140n"
        },
        {
          "order": 8,
          "model": "DCP-J4143N",
          "shopifyUrl": "/collections/dcp-j4143n"
        },
        {
          "order": 9,
          "model": "DCP-J4210N",
          "shopifyUrl": "/collections/dcp-j4210n"
        },
        {
          "order": 10,
          "model": "DCP-J4215N-B/W",
          "shopifyUrl": "/collections/dcp-j4215n-b-w"
        },
        {
          "order": 11,
          "model": "DCP-J4220N",
          "shopifyUrl": "/collections/dcp-j4220n"
        },
        {
          "order": 12,
          "model": "DCP-J515N",
          "shopifyUrl": "/collections/dcp-j515n"
        },
        {
          "order": 13,
          "model": "DCP-J525N",
          "shopifyUrl": "/collections/dcp-j525n"
        },
        {
          "order": 14,
          "model": "DCP-J526N",
          "shopifyUrl": "/collections/dcp-j526n"
        },
        {
          "order": 15,
          "model": "DCP-J528N",
          "shopifyUrl": "/collections/dcp-j528n"
        },
        {
          "order": 16,
          "model": "DCP-J540N",
          "shopifyUrl": "/collections/dcp-j540n"
        },
        {
          "order": 17,
          "model": "DCP-J552N",
          "shopifyUrl": "/collections/dcp-j552n"
        },
        {
          "order": 18,
          "model": "DCP-J557N",
          "shopifyUrl": "/collections/dcp-j557n"
        },
        {
          "order": 19,
          "model": "DCP-J562N",
          "shopifyUrl": "/collections/dcp-j562n"
        },
        {
          "order": 20,
          "model": "DCP-J567N",
          "shopifyUrl": "/collections/dcp-j567n"
        },
        {
          "order": 21,
          "model": "DCP-J572N",
          "shopifyUrl": "/collections/dcp-j572n"
        },
        {
          "order": 22,
          "model": "DCP-J577N",
          "shopifyUrl": "/collections/dcp-j577n"
        },
        {
          "order": 23,
          "model": "DCP-J582N",
          "shopifyUrl": "/collections/dcp-j582n"
        },
        {
          "order": 24,
          "model": "DCP-J587N",
          "shopifyUrl": "/collections/dcp-j587n"
        },
        {
          "order": 25,
          "model": "DCP-J715N",
          "shopifyUrl": "/collections/dcp-j715n"
        },
        {
          "order": 26,
          "model": "DCP-J725N",
          "shopifyUrl": "/collections/dcp-j725n"
        },
        {
          "order": 27,
          "model": "DCP-J740N",
          "shopifyUrl": "/collections/dcp-j740n"
        },
        {
          "order": 28,
          "model": "DCP-J752N",
          "shopifyUrl": "/collections/dcp-j752n"
        },
        {
          "order": 29,
          "model": "DCP-J757N",
          "shopifyUrl": "/collections/dcp-j757n"
        },
        {
          "order": 30,
          "model": "DCP-J762N",
          "shopifyUrl": "/collections/dcp-j762n"
        },
        {
          "order": 31,
          "model": "DCP-J914N",
          "shopifyUrl": "/collections/dcp-j914n"
        },
        {
          "order": 32,
          "model": "DCP-J915N",
          "shopifyUrl": "/collections/dcp-j915n"
        },
        {
          "order": 33,
          "model": "DCP-J925N",
          "shopifyUrl": "/collections/dcp-j925n"
        },
        {
          "order": 34,
          "model": "DCP-J926N-W",
          "shopifyUrl": "/collections/dcp-j926n-w"
        },
        {
          "order": 35,
          "model": "DCP-J926N-B",
          "shopifyUrl": "/collections/dcp-j926n-b"
        },
        {
          "order": 36,
          "model": "DCP-J928N-W",
          "shopifyUrl": "/collections/dcp-j928n-w"
        },
        {
          "order": 37,
          "model": "DCP-J928N-B",
          "shopifyUrl": "/collections/dcp-j928n-b"
        },
        {
          "order": 38,
          "model": "DCP-J940N-B/W",
          "shopifyUrl": "/collections/dcp-j940n-b-w"
        },
        {
          "order": 39,
          "model": "DCP-J952N",
          "shopifyUrl": "/collections/dcp-j952n"
        },
        {
          "order": 40,
          "model": "DCP-J957N",
          "shopifyUrl": "/collections/dcp-j957n"
        },
        {
          "order": 41,
          "model": "DCP-J962N",
          "shopifyUrl": "/collections/dcp-j962n"
        },
        {
          "order": 42,
          "model": "DCP-J963N-B/W",
          "shopifyUrl": "/collections/dcp-j963n-b-w"
        },
        {
          "order": 43,
          "model": "DCP-J968N",
          "shopifyUrl": "/collections/dcp-j968n"
        },
        {
          "order": 44,
          "model": "DCP-J972N",
          "shopifyUrl": "/collections/dcp-j972n"
        },
        {
          "order": 45,
          "model": "DCP-J973N",
          "shopifyUrl": "/collections/dcp-j973n"
        },
        {
          "order": 46,
          "model": "DCP-J978N",
          "shopifyUrl": "/collections/dcp-j978n"
        },
        {
          "order": 47,
          "model": "DCP-J982N",
          "shopifyUrl": "/collections/dcp-j982n"
        },
        {
          "order": 48,
          "model": "DCP-J983N",
          "shopifyUrl": "/collections/dcp-j983n"
        },
        {
          "order": 49,
          "model": "DCP-J983N",
          "shopifyUrl": "/collections/dcp-j983n"
        },
        {
          "order": 50,
          "model": "DCP-J987N",
          "shopifyUrl": "/collections/dcp-j987n"
        },
        {
          "order": 51,
          "model": "DCP-J988N",
          "shopifyUrl": "/collections/dcp-j988n"
        }
      ]
    },
    {
      "order": 4,
      "name": "MFC-1XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-100",
          "shopifyUrl": "/collections/mfc-100"
        },
        {
          "order": 2,
          "model": "MFC-150CL",
          "shopifyUrl": "/collections/mfc-150cl"
        },
        {
          "order": 3,
          "model": "MFC-150CLW",
          "shopifyUrl": "/collections/mfc-150clw"
        }
      ]
    },
    {
      "order": 5,
      "name": "MFC-4XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-410CN",
          "shopifyUrl": "/collections/mfc-410cn"
        },
        {
          "order": 2,
          "model": "MFC-425CN",
          "shopifyUrl": "/collections/mfc-425cn"
        },
        {
          "order": 3,
          "model": "MFC-460CN",
          "shopifyUrl": "/collections/mfc-460cn"
        },
        {
          "order": 4,
          "model": "MFC-480CN",
          "shopifyUrl": "/collections/mfc-480cn"
        },
        {
          "order": 5,
          "model": "MFC-490CN",
          "shopifyUrl": "/collections/mfc-490cn"
        },
        {
          "order": 6,
          "model": "MFC-495CN",
          "shopifyUrl": "/collections/mfc-495cn"
        }
      ]
    },
    {
      "order": 6,
      "name": "MFC-5XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-5840CN",
          "shopifyUrl": "/collections/mfc-5840cn"
        },
        {
          "order": 2,
          "model": "MFC-5860CN",
          "shopifyUrl": "/collections/mfc-5860cn"
        },
        {
          "order": 3,
          "model": "MFC-5890CN",
          "shopifyUrl": "/collections/mfc-5890cn"
        }
      ]
    },
    {
      "order": 7,
      "name": "MFC-6XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-610CLN",
          "shopifyUrl": "/collections/mfc-610cln"
        },
        {
          "order": 2,
          "model": "MFC-610CLWN",
          "shopifyUrl": "/collections/mfc-610clwn"
        },
        {
          "order": 3,
          "model": "MFC-615CL",
          "shopifyUrl": "/collections/mfc-615cl"
        },
        {
          "order": 4,
          "model": "MFC-620CLN",
          "shopifyUrl": "/collections/mfc-620cln"
        },
        {
          "order": 5,
          "model": "MFC-630CD",
          "shopifyUrl": "/collections/mfc-630cd"
        },
        {
          "order": 6,
          "model": "MFC-630CDW",
          "shopifyUrl": "/collections/mfc-630cdw"
        },
        {
          "order": 7,
          "model": "MFC-650CD",
          "shopifyUrl": "/collections/mfc-650cd"
        },
        {
          "order": 8,
          "model": "MFC-650CDW",
          "shopifyUrl": "/collections/mfc-650cdw"
        },
        {
          "order": 9,
          "model": "MFC-670CD",
          "shopifyUrl": "/collections/mfc-670cd"
        },
        {
          "order": 10,
          "model": "MFC-670CDW",
          "shopifyUrl": "/collections/mfc-670cdw"
        },
        {
          "order": 11,
          "model": "MFC-675CD",
          "shopifyUrl": "/collections/mfc-675cd"
        },
        {
          "order": 12,
          "model": "MFC-675CDW",
          "shopifyUrl": "/collections/mfc-675cdw"
        },
        {
          "order": 13,
          "model": "MFC-695CDN",
          "shopifyUrl": "/collections/mfc-695cdn"
        },
        {
          "order": 14,
          "model": "MFC-695CDWN",
          "shopifyUrl": "/collections/mfc-695cdwn"
        },
        {
          "order": 15,
          "model": "MFC-6490CN",
          "shopifyUrl": "/collections/mfc-6490cn"
        },
        {
          "order": 16,
          "model": "MFC-6890CN",
          "shopifyUrl": "/collections/mfc-6890cn"
        }
      ]
    },
    {
      "order": 8,
      "name": "MFC-7XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-735CD",
          "shopifyUrl": "/collections/mfc-735cd"
        },
        {
          "order": 2,
          "model": "MFC-735CDW",
          "shopifyUrl": "/collections/mfc-735cdw"
        }
      ]
    },
    {
      "order": 9,
      "name": "MFC-8XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-820CN",
          "shopifyUrl": "/collections/mfc-820cn"
        },
        {
          "order": 2,
          "model": "MFC-830CLN",
          "shopifyUrl": "/collections/mfc-830cln"
        },
        {
          "order": 3,
          "model": "MFC-830CLWN",
          "shopifyUrl": "/collections/mfc-830clwn"
        },
        {
          "order": 4,
          "model": "MFC-840CLN",
          "shopifyUrl": "/collections/mfc-840cln"
        },
        {
          "order": 5,
          "model": "MFC-850CDN",
          "shopifyUrl": "/collections/mfc-850cdn"
        },
        {
          "order": 6,
          "model": "MFC-850CDWN",
          "shopifyUrl": "/collections/mfc-850cdwn"
        },
        {
          "order": 7,
          "model": "MFC-860CDN",
          "shopifyUrl": "/collections/mfc-860cdn"
        },
        {
          "order": 8,
          "model": "MFC-870CDN",
          "shopifyUrl": "/collections/mfc-870cdn"
        },
        {
          "order": 9,
          "model": "MFC-870CDWN",
          "shopifyUrl": "/collections/mfc-870cdwn"
        },
        {
          "order": 10,
          "model": "MFC-880CDN",
          "shopifyUrl": "/collections/mfc-880cdn"
        },
        {
          "order": 11,
          "model": "MFC-880CDWN",
          "shopifyUrl": "/collections/mfc-880cdwn"
        }
      ]
    },
    {
      "order": 10,
      "name": "MFC-9XXシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-930CDN",
          "shopifyUrl": "/collections/mfc-930cdn"
        },
        {
          "order": 2,
          "model": "MFC-930CDWN",
          "shopifyUrl": "/collections/mfc-930cdwn"
        },
        {
          "order": 3,
          "model": "MFC-935CDN",
          "shopifyUrl": "/collections/mfc-935cdn"
        },
        {
          "order": 4,
          "model": "MFC-935CDWN",
          "shopifyUrl": "/collections/mfc-935cdwn"
        }
      ]
    },
    {
      "order": 11,
      "name": "MFC-Jシリーズ",
      "models": [
        {
          "order": 1,
          "model": "MFC-J615N",
          "shopifyUrl": "/collections/mfc-j615n"
        },
        {
          "order": 2,
          "model": "MFC-J700D",
          "shopifyUrl": "/collections/mfc-j700d"
        },
        {
          "order": 3,
          "model": "MFC-J700DW",
          "shopifyUrl": "/collections/mfc-j700dw"
        },
        {
          "order": 4,
          "model": "MFC-J705D/DW",
          "shopifyUrl": "/collections/mfc-j705d-dw"
        },
        {
          "order": 5,
          "model": "MFC-J710D/DW",
          "shopifyUrl": "/collections/mfc-j710d-dw"
        },
        {
          "order": 6,
          "model": "MFC-J7100CDW",
          "shopifyUrl": "/collections/mfc-j7100cdw"
        },
        {
          "order": 7,
          "model": "MFC-J720D",
          "shopifyUrl": "/collections/mfc-j720d"
        },
        {
          "order": 8,
          "model": "MFC-J727D",
          "shopifyUrl": "/collections/mfc-j727d"
        },
        {
          "order": 9,
          "model": "MFC-J720DW",
          "shopifyUrl": "/collections/mfc-j720dw"
        },
        {
          "order": 10,
          "model": "MFC-J727DW",
          "shopifyUrl": "/collections/mfc-j727dw"
        },
        {
          "order": 11,
          "model": "MFC-J730DN",
          "shopifyUrl": "/collections/mfc-j730dn"
        },
        {
          "order": 12,
          "model": "MFC-J730DWN",
          "shopifyUrl": "/collections/mfc-j730dwn"
        },
        {
          "order": 13,
          "model": "MFC-J7300CDW",
          "shopifyUrl": "/collections/mfc-j7300cdw"
        },
        {
          "order": 14,
          "model": "MFC-J737DN",
          "shopifyUrl": "/collections/mfc-j737dn"
        },
        {
          "order": 15,
          "model": "MFC-J737DWN",
          "shopifyUrl": "/collections/mfc-j737dwn"
        },
        {
          "order": 16,
          "model": "MFC-J738DN",
          "shopifyUrl": "/collections/mfc-j738dn"
        },
        {
          "order": 17,
          "model": "MFC-J738DWN",
          "shopifyUrl": "/collections/mfc-j738dwn"
        },
        {
          "order": 18,
          "model": "MFC-J739DN",
          "shopifyUrl": "/collections/mfc-j739dn"
        },
        {
          "order": 19,
          "model": "MFC-J739DWN",
          "shopifyUrl": "/collections/mfc-j739dwn"
        },
        {
          "order": 20,
          "model": "MFC-J742DN",
          "shopifyUrl": "/collections/mfc-j742dn"
        },
        {
          "order": 21,
          "model": "MFC-J742DWN",
          "shopifyUrl": "/collections/mfc-j742dwn"
        },
        {
          "order": 22,
          "model": "MFC-J7600CDW",
          "shopifyUrl": "/collections/mfc-j7600cdw"
        },
        {
          "order": 23,
          "model": "MFC-J7500CDW",
          "shopifyUrl": "/collections/mfc-j7500cdw"
        },
        {
          "order": 24,
          "model": "MFC-J7700CDW",
          "shopifyUrl": "/collections/mfc-j7700cdw"
        },
        {
          "order": 25,
          "model": "MFC-J800D",
          "shopifyUrl": "/collections/mfc-j800d"
        },
        {
          "order": 26,
          "model": "MFC-J800DW",
          "shopifyUrl": "/collections/mfc-j800dw"
        },
        {
          "order": 27,
          "model": "MFC-J805D/DW",
          "shopifyUrl": "/collections/mfc-j805d-dw"
        },
        {
          "order": 28,
          "model": "MFC-J810DN/DWN",
          "shopifyUrl": "/collections/mfc-j810dn-dwn"
        },
        {
          "order": 29,
          "model": "MFC-J820DN",
          "shopifyUrl": "/collections/mfc-j820dn"
        },
        {
          "order": 30,
          "model": "MFC-J820DWN",
          "shopifyUrl": "/collections/mfc-j820dwn"
        },
        {
          "order": 31,
          "model": "MFC-J825N",
          "shopifyUrl": "/collections/mfc-j825n"
        },
        {
          "order": 32,
          "model": "MFC-J827DN",
          "shopifyUrl": "/collections/mfc-j827dn"
        },
        {
          "order": 33,
          "model": "MFC-J827DWN",
          "shopifyUrl": "/collections/mfc-j827dwn"
        },
        {
          "order": 34,
          "model": "MFC-J830DN",
          "shopifyUrl": "/collections/mfc-j830dn"
        },
        {
          "order": 35,
          "model": "MFC-J830DWN",
          "shopifyUrl": "/collections/mfc-j830dwn"
        },
        {
          "order": 36,
          "model": "MFC-J840N",
          "shopifyUrl": "/collections/mfc-j840n"
        },
        {
          "order": 37,
          "model": "MFC-J850DN",
          "shopifyUrl": "/collections/mfc-j850dn"
        },
        {
          "order": 38,
          "model": "MFC-J850DWN",
          "shopifyUrl": "/collections/mfc-j850dwn"
        },
        {
          "order": 39,
          "model": "MFC-J855DN/DWN",
          "shopifyUrl": "/collections/mfc-j855dn-dwn"
        },
        {
          "order": 40,
          "model": "MFC-J860DN/DWN",
          "shopifyUrl": "/collections/mfc-j860dn-dwn"
        },
        {
          "order": 41,
          "model": "MFC-J870N",
          "shopifyUrl": "/collections/mfc-j870n"
        },
        {
          "order": 42,
          "model": "MFC-J877N",
          "shopifyUrl": "/collections/mfc-j877n"
        },
        {
          "order": 43,
          "model": "MFC-J880N",
          "shopifyUrl": "/collections/mfc-j880n"
        },
        {
          "order": 44,
          "model": "MFC-J887N",
          "shopifyUrl": "/collections/mfc-j887n"
        },
        {
          "order": 45,
          "model": "MFC-J890DN",
          "shopifyUrl": "/collections/mfc-j890dn"
        },
        {
          "order": 46,
          "model": "MFC-J890DWN",
          "shopifyUrl": "/collections/mfc-j890dwn"
        },
        {
          "order": 47,
          "model": "MFC-J893N",
          "shopifyUrl": "/collections/mfc-j893n"
        },
        {
          "order": 48,
          "model": "MFC-J897DN",
          "shopifyUrl": "/collections/mfc-j897dn"
        },
        {
          "order": 49,
          "model": "MFC-J897DWN",
          "shopifyUrl": "/collections/mfc-j897dwn"
        },
        {
          "order": 50,
          "model": "MFC-J898N",
          "shopifyUrl": "/collections/mfc-j898n"
        },
        {
          "order": 51,
          "model": "MFC-J900DN",
          "shopifyUrl": "/collections/mfc-j900dn"
        },
        {
          "order": 52,
          "model": "MFC-J903N",
          "shopifyUrl": "/collections/mfc-j903n"
        },
        {
          "order": 53,
          "model": "MFC-J904N",
          "shopifyUrl": "/collections/mfc-j904n"
        },
        {
          "order": 54,
          "model": "MFC-J905N",
          "shopifyUrl": "/collections/mfc-j905n"
        },
        {
          "order": 55,
          "model": "MFC-J939DN/DWN",
          "shopifyUrl": "/collections/mfc-j939dn-dwn"
        },
        {
          "order": 56,
          "model": "MFC-J939DWN",
          "shopifyUrl": "/collections/mfc-j939dwn"
        },
        {
          "order": 57,
          "model": "MFC-J950DN",
          "shopifyUrl": "/collections/mfc-j950dn"
        },
        {
          "order": 58,
          "model": "MFC-J950DWN",
          "shopifyUrl": "/collections/mfc-j950dwn"
        },
        {
          "order": 59,
          "model": "MFC-J955DN/DWN",
          "shopifyUrl": "/collections/mfc-j955dn-dwn"
        },
        {
          "order": 60,
          "model": "MFC-J960DN-B/W",
          "shopifyUrl": "/collections/mfc-j960dn-b-w"
        },
        {
          "order": 61,
          "model": "MFC-J960DWN-B/W",
          "shopifyUrl": "/collections/mfc-j960dwn-b-w"
        },
        {
          "order": 62,
          "model": "MFC-J980DN",
          "shopifyUrl": "/collections/mfc-j980dn"
        },
        {
          "order": 63,
          "model": "MFC-J980DWN",
          "shopifyUrl": "/collections/mfc-j980dwn"
        },
        {
          "order": 64,
          "model": "MFC-J987DN",
          "shopifyUrl": "/collections/mfc-j987dn"
        },
        {
          "order": 65,
          "model": "MFC-J987DWN",
          "shopifyUrl": "/collections/mfc-j987dwn"
        },
        {
          "order": 66,
          "model": "MFC-J990DN",
          "shopifyUrl": "/collections/mfc-j990dn"
        },
        {
          "order": 67,
          "model": "MFC-J990DWN",
          "shopifyUrl": "/collections/mfc-j990dwn"
        },
        {
          "order": 68,
          "model": "MFC-J998DN",
          "shopifyUrl": "/collections/mfc-j998dn"
        },
        {
          "order": 69,
          "model": "MFC-J998DWN",
          "shopifyUrl": "/collections/mfc-j998dwn"
        },
        {
          "order": 70,
          "model": "MFC-J1500N",
          "shopifyUrl": "/collections/mfc-j1500n"
        },
        {
          "order": 71,
          "model": "MFC-J1605DN",
          "shopifyUrl": "/collections/mfc-j1605dn"
        },
        {
          "order": 72,
          "model": "MFC-J4440N",
          "shopifyUrl": "/collections/mfc-j4440n"
        },
        {
          "order": 73,
          "model": "MFC-J4443N",
          "shopifyUrl": "/collections/mfc-j4443n"
        },
        {
          "order": 74,
          "model": "MFC-J4510N",
          "shopifyUrl": "/collections/mfc-j4510n"
        },
        {
          "order": 75,
          "model": "MFC-J4540N",
          "shopifyUrl": "/collections/mfc-j4540n"
        },
        {
          "order": 76,
          "model": "MFC-J4543N",
          "shopifyUrl": "/collections/mfc-j4543n"
        },
        {
          "order": 77,
          "model": "MFC-J4720N",
          "shopifyUrl": "/collections/mfc-j4720n"
        },
        {
          "order": 78,
          "model": "MFC-J4810DN",
          "shopifyUrl": "/collections/mfc-j4810dn"
        },
        {
          "order": 79,
          "model": "MFC-J4910CDW",
          "shopifyUrl": "/collections/mfc-j4910cdw"
        },
        {
          "order": 80,
          "model": "MFC-J4940DN",
          "shopifyUrl": "/collections/mfc-j4940dn"
        },
        {
          "order": 81,
          "model": "MFC-J5620CDW",
          "shopifyUrl": "/collections/mfc-j5620cdw"
        },
        {
          "order": 82,
          "model": "MFC-J5630CDW",
          "shopifyUrl": "/collections/mfc-j5630cdw"
        },
        {
          "order": 83,
          "model": "MFC-J5720CDW",
          "shopifyUrl": "/collections/mfc-j5720cdw"
        },
        {
          "order": 84,
          "model": "MFC-J5820DN",
          "shopifyUrl": "/collections/mfc-j5820dn"
        },
        {
          "order": 85,
          "model": "MFC-J5800CDW",
          "shopifyUrl": "/collections/mfc-j5800cdw"
        },
        {
          "order": 86,
          "model": "MFC-J5910CDW",
          "shopifyUrl": "/collections/mfc-j5910cdw"
        },
        {
          "order": 87,
          "model": "MFC-J6510DW",
          "shopifyUrl": "/collections/mfc-j6510dw"
        },
        {
          "order": 88,
          "model": "MFC-J6570CDW",
          "shopifyUrl": "/collections/mfc-j6570cdw"
        },
        {
          "order": 89,
          "model": "MFC-J6573CDW",
          "shopifyUrl": "/collections/mfc-j6573cdw"
        },
        {
          "order": 90,
          "model": "MFC-J6580CDW",
          "shopifyUrl": "/collections/mfc-j6580cdw"
        },
        {
          "order": 91,
          "model": "MFC-J6583CDW",
          "shopifyUrl": "/collections/mfc-j6583cdw"
        },
        {
          "order": 92,
          "model": "MFC-J6710CDW",
          "shopifyUrl": "/collections/mfc-j6710cdw"
        },
        {
          "order": 93,
          "model": "MFC-J6770CDW",
          "shopifyUrl": "/collections/mfc-j6770cdw"
        },
        {
          "order": 94,
          "model": "MFC-J6910CDW",
          "shopifyUrl": "/collections/mfc-j6910cdw"
        },
        {
          "order": 95,
          "model": "MFC-J6970CDW",
          "shopifyUrl": "/collections/mfc-j6970cdw"
        },
        {
          "order": 96,
          "model": "MFC-J6973CDW",
          "shopifyUrl": "/collections/mfc-j6973cdw"
        },
        {
          "order": 97,
          "model": "MFC-J6975CDW",
          "shopifyUrl": "/collections/mfc-j6975cdw"
        },
        {
          "order": 98,
          "model": "MFC-J6980CDW",
          "shopifyUrl": "/collections/mfc-j6980cdw"
        },
        {
          "order": 99,
          "model": "MFC-J6983CDW",
          "shopifyUrl": "/collections/mfc-j6983cdw"
        },
        {
          "order": 100,
          "model": "MFC-J6995CDW",
          "shopifyUrl": "/collections/mfc-j6995cdw"
        },
        {
          "order": 101,
          "model": "MFC-J6997CDW",
          "shopifyUrl": "/collections/mfc-j6997cdw"
        },
        {
          "order": 102,
          "model": "MFC-J6999CDW",
          "shopifyUrl": "/collections/mfc-j6999cdw"
        }
      ]
    }
  ]
};
